import { useNavigate, useParams } from "react-router-dom";
import { COMMON_CONSTANTS, I18_TRANSLATION_COMMON, NUMBER_CONSTANTS, ROUTES } from "../../../Utilities/Constants/Constants";
import { Container, FormControl, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { SetSessionStorageData, nullUndefinedEmptyCheck } from "../../../Services/Helpers/Helper";
import { useEffect, useState } from "react";
import React from "react";
import { useSelector } from "react-redux";
import { axiosInstance } from "../../../Services/Interceptor/Interceptor";
import API_END_POINTS from "../../../Utilities/Constants/ApiEndpoints";
import tutor_img from "../../../../Assets/users/TutorImg.svg";
import activitiesIcon from "../../../../Assets/users/activitiesIcon.svg";
import "./BookingDetail.scss";
import NoProducts from "../../../Shared/NoProducts/NoProducts";
import BackArrow from "../../../../Assets/schools/back_button.svg";
import { useTranslation } from "react-i18next";
import TutorImg from "../../Assets/Tutor/TutorImg.svg";
import moment from 'moment';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { Card } from "@mui/material";


const BookingDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation(I18_TRANSLATION_COMMON.COMMON);
  const [TutorHubList, setTutorHubList] = useState<any>([]);
  const [ActivityHubList, setActivityHubList] = useState<any>([]);
  const [ThemeParkHubList, setThemeParkHubList] = useState<any>([])
  const [ActiveList, setActiveList] = useState<any>(
    NUMBER_CONSTANTS.ONE
  );
  
  const [sortValue, setSortValue] = useState(
    COMMON_CONSTANTS.ALL
  );
  const [searchValue, setSearchValue] = useState("");
  const [isTodayTutor, setIsTodayTutor] = useState(false);
  const [isTodayActivity, setIsTodayActivity] = useState(false);

  useEffect(() => {

    let tabName = ActiveList == 1 ? "Tutor Bookings" : ActiveList == 2 ? "Activity Bookings" : " Theme park Bookings"
    const pathName = window.location?.pathname;
    let pathWithTab = `${pathName}/${tabName}`
    const payload = {
      record_area: pathWithTab
    }
    axiosInstance.post(`${API_END_POINTS?.RECORD_AREA}`, payload).then((response: any) => {
    }).catch(() => {
    })
  }, [ActiveList])

  const navigateDetailes = (value: any, state: any) => {
  };

  const Loader: any = useSelector((state: any) => {
    return state.loaderReducer.loader;
  });

  const onNavigate = (booked_id: any, id: any, state: any) => {
    navigate(`/manage-users/${booked_id}/bookings/${id}`, { state: state })
  }

  useEffect(() => {
    getTutorHubData("", searchValue);
    getActivityHubData("", searchValue);
    getThemeParkHubData("", searchValue);
  }, [isTodayTutor, isTodayActivity]);

  const getTutorHubData = (value: any, search: any) => {
    axiosInstance
      .get(
        `${API_END_POINTS.TUTOR_HUB_LIST + `?id=${id}`
        }`
      )
      .then((Response: any) => {
        if (Response?.data?.status) {
          setTutorHubList(Response?.data?.result?.data);
        }
      })
      .catch(() => { });
  };

  const getActivityHubData = (value: any, search: any) => {
    axiosInstance
      .get(
        `${API_END_POINTS.RECREATIONAL_HUB + `?id=${id}`
        }`
      )
      .then((Response: any) => {
        if (Response?.data?.status) {
          setActivityHubList(Response?.data?.result?.data);
        }
      })
      .catch(() => { });
  };

  const getThemeParkHubData = (value: any, search: any) => {
    axiosInstance

      .get(
        `${API_END_POINTS.THEMEPARK_HUB + `?id=${id}` 
        }`
      )
      .then((Response: any) => {
        if (Response?.data?.status) {
          setThemeParkHubList(Response?.data?.result?.data);
        }
      })
      .catch(() => { });
  };

  const handleOpenNewTab = (url: any) => {
    window.open(url, "_blank");
  };

  const handleChange = (event: SelectChangeEvent) => {
    if (event.target.value === COMMON_CONSTANTS.ALL) {
      setSortValue(event.target.value);
      if (ActiveList === NUMBER_CONSTANTS.ONE) {
        getTutorHubData("", searchValue);
      } else {
        getActivityHubData("", searchValue);
      }
    } else {
      setSortValue(event.target.value);
      if (ActiveList === NUMBER_CONSTANTS.ONE) {
        getTutorHubData(event.target.value, searchValue);
      } else {
        getActivityHubData(event.target.value, searchValue);
      }
    }
  };

  const handleSwitch = (val: any) => {
    setActiveList(val);
    getTutorHubData("", "");
    getActivityHubData("", "");
    getThemeParkHubData("", "");
    setSortValue(COMMON_CONSTANTS.ALL);
    setSearchValue("");
  };

  const handleInputChange = () => {
    if (ActiveList === NUMBER_CONSTANTS.ONE) {
      getTutorHubData(
        sortValue == COMMON_CONSTANTS.ALL
          ? ""
          : sortValue,
        searchValue
      );
    } else {
      getActivityHubData(
        sortValue == COMMON_CONSTANTS.ALL
          ? ""
          : sortValue,
        searchValue
      );
    }
  };

  return (
    <>
      <React.Fragment>
        <Container component="main" maxWidth="xl" sx={{ mb: 4 }}>
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div className="arrow-wrap">
                <img
                  alt="Learn and Play"
                  src={BackArrow}
                  className="EditSchool-backarrow"
                  onClick={() => {
                    navigate(-1);
                  }}
                />
                <h5 className="name-title mt-1 ms-1">{t("Booking Detail")}</h5>
              </div>
            </div>
          </div>

          <div className="Tutor_hup__container">

            <div className="header__section">
              <div className="left__contant">
                <div
                  className={ActiveList === 1 ? "tutor__active" : "title"}
                  onClick={() => handleSwitch(1)}
                >
                  Tutor Bookings
                </div>
                <div
                  className={ActiveList === 2 ? "Activity__active" : "title"}
                  onClick={() => handleSwitch(2)}
                >
                  Activity Bookings
                </div>
                <div
                  className={ActiveList === 3 ? " themepark_active" : "title"}
                  onClick={() => handleSwitch(3)}
                >
                  Theme park Bookings
                </div>
              </div>
              <div className="left__contant">
               
              </div>
            </div>
            <div className="tutor_hub__card__container row">
              {ActiveList === NUMBER_CONSTANTS.ONE && (
                <>
                  <div className="col-xl-12 col-lg-12 col-md-12 col-12">

                  </div>
                  {TutorHubList?.map((data: any) => {
                    return (
                      <>
                        <div className="col-xl-6 col-lg-6 col-md-12 col-12">
                          <div className="card_wapper">
                            <div className="Profile_contant">
                              <div
                                className="tutor__contant"
                                onClick={() =>
                                  navigateDetailes(
                                    data,
                                    NUMBER_CONSTANTS.ONE
                                  )
                                }
                              >
                                <img
                                  src={
                                    nullUndefinedEmptyCheck(
                                      data?.session_creator_profile
                                    )
                                      ? data?.session_creator_profile
                                      : tutor_img
                                  }
                                  className="profile__Img"
                                  alt=""
                                />
                                <div className="d-flex flex-column">
                                  <div className="Profile__name__text">
                                    {data?.session_creator_name}
                                  </div>
                                  <div className="name__text">{data?.type}</div>
                                </div>
                              </div>

                              <div className="right_options">

                                {data?.is_online && (
                                  <div
                                    className="video_call__wapeer"
                                    onClick={() =>
                                      navigateDetailes(
                                        data,
                                        NUMBER_CONSTANTS.ONE
                                      )
                                    }
                                  >
                                    <div className="badgeIcon badeg__pos"></div>
                                  </div>
                                )}
                              </div>
                            </div>

                            <div
                              className="tutor__contant"
                              onClick={() =>
                                navigateDetailes(
                                  data,
                                  NUMBER_CONSTANTS.ONE
                                )
                              }
                            >
                              <div className="tutor__img__wapper">
                                <img src={tutor_img} alt="" />
                              </div>
                              <div className="d-flex flex-column">
                                <div className="Black__text">
                                  {data?.session_name[0]}
                                </div>
                                <div className="name__text">
                                  {data?.session_creator_name}
                                </div>
                              </div>
                            </div>

                            <div
                              className="row__contant"
                              onClick={() =>
                                navigateDetailes(
                                  data,
                                  NUMBER_CONSTANTS.ONE
                                )
                              }
                            >
                              <div className="left__light__text">
                                No. of Sessions
                              </div>
                              <div className="right__black__text">
                                {data?.completed_slots_count}/
                                {data?.total_slots_count}
                              </div>
                            </div>
                            <div
                              className="row__contant"
                              onClick={() =>
                                navigateDetailes(
                                  data,
                                  NUMBER_CONSTANTS.ONE
                                )
                              }
                            >
                              <div className="left__light__text">Date </div>
                              <div className="right__black__text">
                                {data?.date}
                              </div>
                            </div>
                            <div
                              className="row__contant"
                              onClick={() =>
                                navigateDetailes(
                                  data,
                                  NUMBER_CONSTANTS.ONE
                                )
                              }
                            >
                              <div className="left__light__text">
                                Booked Time{" "}
                              </div>
                              <div className="d-flex flex-column">
                                {data?.time?.map((item: any) => {
                                  return (
                                    <div className="right__black__text">
                                      {item}
                                    </div>
                                  );
                                })}
                              </div>
                            </div>

                            <div
                              className="row__contant"
                              onClick={() =>
                                navigateDetailes(
                                  data,
                                  NUMBER_CONSTANTS.ONE
                                )
                              }
                            >
                              <button
                                className={
                                  data?.status == "completed"
                                    ? "CompletedBtn"
                                    : "inprogressBtn"
                                }
                              >
                                {data?.status}
                              </button>
                              <div className="d-flex align-items-center">
                                <img
                                  src={
                                    nullUndefinedEmptyCheck(data?.profile)
                                      ? data?.profile
                                      : tutor_img
                                  }
                                  className="child_profile_img"
                                  alt=""
                                />
                                <div className="createdBy ms-2">
                                  {data?.name}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    );
                  })}
                  {TutorHubList?.length === 0 && ActiveList === 1 && <NoProducts />}
                </>
              )}

              {ActiveList === NUMBER_CONSTANTS.TWO && (
                <>
              
                  {ActivityHubList?.map((data: any) => {
                    return (
                      <>
                        <div className="col-xl-6 col-lg-6 col-md-12 col-12">
                          <div className="card_wapper">
                            <div className="Profile_contant">
                              <div
                                className="tutor__contant"
                                onClick={() =>
                                  navigateDetailes(
                                    data,
                                    NUMBER_CONSTANTS.ONE
                                  )
                                }
                              >
                                <img
                                  src={
                                    nullUndefinedEmptyCheck(
                                      data?.session_creator_profile
                                    )
                                      ? data?.session_creator_profile
                                      : tutor_img
                                  }
                                  className="profile__Img"
                                  alt=""
                                />
                                <div className="d-flex flex-column">
                                  <div className="Profile__name__text">
                                    {data?.session_creator_name}
                                  </div>
                                  <div className="name__text">{data?.type}</div>
                                </div>
                              </div>
                              <div className="right_options">
                             
                                {data?.is_online && (
                                  <div
                                    className="video_call__wapeer"
                                    onClick={() =>
                                      handleOpenNewTab(data?.meet_link)
                                    }
                                  >
                                    <div className="badgeIcon badeg__pos"></div>
                                  </div>
                                )}
                              </div>
                            </div>

                            <div
                              className="tutor__contant"
                              onClick={() =>
                                navigateDetailes(
                                  data,
                                  NUMBER_CONSTANTS.ONE
                                )
                              }
                            >
                              <div className="activity__img__wapper">
                                <img src={activitiesIcon} alt="" />
                              </div>
                              <div className="d-flex flex-column">
                                <div className="Black__text">
                                  {data?.session_name}
                                </div>
                                <div className="name__text">
                                  {data?.session_creator_name}
                                </div>
                              </div>
                            </div>

                            <div
                              className="row__contant"
                              onClick={() =>
                                navigateDetailes(
                                  data,
                                  NUMBER_CONSTANTS.ONE
                                )
                              }
                            >
                              <div className="left__light__text">
                                No. of Sessions
                              </div>
                              <div className="right__black__text">
                                {data?.completed_slots_count}/
                                {data?.total_slots_count}
                              </div>
                            </div>
                            <div
                              className="row__contant"
                              onClick={() =>
                                navigateDetailes(
                                  data,
                                  NUMBER_CONSTANTS.ONE
                                )
                              }
                            >
                              <div className="left__light__text">Date </div>
                              <div className="right__black__text">
                                {data?.date}
                              </div>
                            </div>
                            <div
                              className="row__contant"
                              onClick={() =>
                                navigateDetailes(
                                  data,
                                  NUMBER_CONSTANTS.ONE
                                )
                              }
                            >
                              <div className="left__light__text">
                                Booked Time{" "}
                              </div>
                              <div className="d-flex flex-column">
                                {data?.time?.map((item: any) => {
                                  return (
                                    <div className="right__black__text">
                                      {item}
                                    </div>
                                  );
                                })}
                              </div>
                            </div>

                            <div
                              className="row__contant"
                              onClick={() =>
                                navigateDetailes(
                                  data,
                                  NUMBER_CONSTANTS.ONE
                                )
                              }
                            >
                              <button
                                className={
                                  data?.status == "completed"
                                    ? "CompletedBtn"
                                    : "inprogressBtn"
                                }
                              >
                                {data?.status}
                              </button>
                              <div className="d-flex align-items-center">
                                <img
                                  src={
                                    nullUndefinedEmptyCheck(data?.profile)
                                      ? data?.profile
                                      : tutor_img
                                  }
                                  className="child_profile_img"
                                  alt=""
                                />
                                <div className="createdBy ms-2">
                                  {data?.name}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    );
                  })}
                </>
              )}
              {ActivityHubList?.length === 0 && ActiveList === 2 && <NoProducts />}

              {ActiveList === NUMBER_CONSTANTS.THREE && (
                <>
                  <div className="my-tickets-wrapper">
                    <div className="card-wrapper-ticket">
                      {ThemeParkHubList?.map((ticket: any, index: number) => {
                        return (
                          <Card className="ticket-card" onClick={() => onNavigate(ticket.booked_user_id, ticket.id, ticket.ticket_type_details)}>
                            <div className="image-wrapper">
                              <img className="theme-image" src={ticket.themepark_image} />
                              <div className="ticket-name-location">
                                <h5>{ticket.themepark_name}</h5>
                                <p><LocationOnIcon className="location-icon" />{ticket.city ? ticket.city : "N/A"}</p>
                              </div>
                            </div>

                            <div className="theme-details mt-2">
                              <div className="row">
                                <div className="col-sm-6 col-md-6">
                                  <p className="theme-title">{t("Contact No")}</p>
                                </div>
                                <div className="col-sm-6 col-md-6">
                                  <p className="theme-value">{ticket.phone_number}</p>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-sm-6 col-md-6">
                                  <p className="theme-title">{t("Booked ID")}</p>
                                </div>
                                <div className="col-sm-6 col-md-6">
                                  <p className="theme-value">{ticket.id}</p>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-sm-6 col-md-6">
                                  <p className="theme-title">{t("Booked Date")}</p>
                                </div>
                                <div className="col-sm-6 col-md-6">
                                  <p className="theme-value">{moment(new Date(ticket.created_on)).format("DD/MM/YYYY")}</p>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-sm-6 col-md-6">
                                  <p className="theme-title">{t("Booked By")}</p>
                                </div>
                                <div className="col-sm-6 col-md-6">
                                  <p className="theme-value">{ticket.parent_name}</p>
                                </div>
                              </div>
                            </div>
                          </Card>
                        )
                      })
                      }

                    </div>

                  </div>
                </>
              )}
              {ThemeParkHubList?.length === 0 && ActiveList === 2 && <NoProducts />}

            </div>
          </div>
        </Container>
      </React.Fragment>
    </>
  );

};
export default BookingDetail;